import { Skeleton, Table } from '@factorialco/deprecated-design-system'
import { range, sample } from 'lodash'

interface Props {
  tableHeaders: string[]
}

export const ApplicationsSourceSkeleton = ({ tableHeaders }: Props) => {
  const rowsCount = tableHeaders.length - 1

  return (
    <Table hideBorder fullWidth>
      <Table.Row>
        {tableHeaders.map((header) => (
          <Table.Cell key={header} paddingX="s0">
            {header}
          </Table.Cell>
        ))}
      </Table.Row>
      {range(rowsCount).map((rowKey) => (
        <Table.Row key={rowKey}>
          {range(rowsCount + 1).map((colKey) => (
            <Table.Cell noBorder paddingX="s0" key={colKey}>
              <Skeleton width={sample(['s80', 's96', 's48', 's64', 's32', 's40'])} />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table>
  )
}
